import React from 'react';
import { Routes, Route } from 'react-router-dom';
import RecipesPage from './RecipesPage';
import RecipeEditPage from './RecipeEditPage';

/** Pages under /casa/receitas. */
const RecipesRoutes: React.FC = () => (
  <Routes>
    <Route index element={<RecipesPage />} />
    <Route path="nova" element={<RecipeEditPage />} />
    <Route path=":id" element={<RecipeEditPage />} />
  </Routes>
);

export default RecipesRoutes;
